import { type ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { providePrimeNG } from 'primeng/config';
import { MyTheme } from './app.theme';
import { routes } from './app.routes';
import { MessageService } from 'primeng/api';
import {
  httpLoggerInterceptor,
  httpCorrelationInterceptor,
  authInterceptor,
  errorInterceptor,
  spinnerInterceptor,
} from '@core/interceptors';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(
      withInterceptors([
        httpLoggerInterceptor,
        httpCorrelationInterceptor,
        authInterceptor,
        errorInterceptor,
        spinnerInterceptor,
      ])
    ),
    provideAnimationsAsync(),
    CookieService,
    MessageService,
    providePrimeNG({
      theme: {
        preset: MyTheme,
        options: {
          darkModeSelector: '.my-app-dark',
          cssLayer: {
            name: 'primeng',
            order: 'tailwind-base, primeng, tailwind-utilities',
          },
        },
      },
    }),
  ],
};
